export const SORT_BY_FORM_NAME = 'SORT_BY_FORM'
export const SORT_BY_INPUT_NAME = 'sortBy'
export const SORT_BY_INPUT_LABEL = 'Sort by'
